import React, { useCallback, useState } from 'react';
import { useAuthenticatedSession, useToast } from '../../hooks';
import { Button, Input, InputPhone } from '../../components';
import { MainLayout } from '../../components/layouts';
import { Container } from './styles';
import { updatePhoneNumber } from '../../services/AuthService';

type FormError = {
    field: string;
    message: string;
}

type FormData = {
    name?: string;
    email?: string;
    phone?: string;
    company?: string;
}

const ProfilePage: React.FC = () => {
    const { user, editUser, handleRequest } = useAuthenticatedSession();

    const { showToast } = useToast();
    const [formData, setFormData] = useState<FormData>({
        ...user,
        phone: user.phoneNumber
    });
    const [errors, setErrors] = useState<FormError[]>([]);
    const [isIncompletePhone, setIsIncompletePhone] = useState<boolean>(false);

    const handleChange = useCallback((newData: FormData) => setFormData(oldData => ({
        ...oldData,
        ...newData
    })), []);

    const handleSave = useCallback(async () => {
        const { phone } = formData;

        if (isIncompletePhone) {
            setErrors(oldErrors => [...oldErrors, {
                field: 'phone',
                message: 'Incompleto'
            }]);
            return;
        } 

        setErrors([]);

        const response = await handleRequest(async () => {
            await updatePhoneNumber(phone);
        });

        if (response.success) {
            editUser({
                ...user,
                phoneNumber: phone
            });

            showToast({
                type: 'success',
                message: 'Perfil salvo com sucesso'
            });
        }

    }, [showToast, editUser, handleRequest, user, formData, isIncompletePhone]);

    const isDisabledSaveButton = useCallback(() => 
        isIncompletePhone || formData.phone === user.phoneNumber, [isIncompletePhone, formData, user]);

    return (
        <MainLayout id="profile" title="Perfil">
            <Container>
                <span>(*) Preenchimento obrigatório</span>
                <form>
                    <Input
                        id="profile.name"
                        type="text"
                        disabled
                        label="Nome"
                        value={user.name}
                    />
                    <Input
                        id="profile.email"
                        type="email"
                        disabled
                        label="E-mail"
                        value={user.email}
                    />
                    <InputPhone
                        id="profile.phone"
                        label="Telefone/Celular"
                        placeholder="Digite seu telefone de contato"
                        defaultValue={user.phoneNumber}
                        getValue={({ value, incomplete }) => {
                            handleChange({
                                phone: value
                            });
                            setIsIncompletePhone(incomplete);
                        }}
                        error={errors.filter(({ field }) => field === 'phone')[0]?.message}
                    />
                    <Input
                        id="profile.company"
                        type="text"
                        disabled
                        label="Empresa"
                        value={user.enterpriseName}
                    />
                </form>
                <small>Caso precise alterar nome, e-mail ou empresa, entre em contato com a Flix Media.</small>
                <Button
                    id="profile.savebutton"
                    disabled={isDisabledSaveButton()}
                    onClick={handleSave}
                >
                    Salvar
                </Button>
            </Container>
        </MainLayout>
    );
};

export { ProfilePage };
